export const MANAGER_STATUS_LIST_MUTATION = "MANAGER_STATUS_LIST_MUTATION";
